var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.openFileBrowser}},[_vm._t("btn",null,{"loading":_vm.loading}),_c('input',{ref:"input",attrs:{"type":"file","multiple":_vm.multiple},on:{"change":_vm.changeEvent}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }